export default "__VITE_ASSET__CSshhmMB__"